import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { useField } from 'formik';
import { FormFeedback } from '~/components/FormControl';
import classNames from 'classnames/bind';
const cx = classNames.bind();
import { MaterialReactTable } from 'material-react-table';

function ConsumableEffectTable({ resetCount }) {
    const [, meta, helpers] = useField({
        name: 'use',
    });

    const { consumableEffects: rows } = useSelector((state) => state.itemSaga.consumable);

    const columns = React.useMemo(
        () => [
            {
                accessorFn: (originalRow) => originalRow.id, //alternate way
                header: 'ID',
                id: 'id',
                size: 50,
            },
            {
                accessorFn: (originalRow) => originalRow.effect, //alternate way
                id: 'effect', //id required if you use accessorFn instead of accessorKey
                header: 'Effect',
            },
        ],
        [],
    );

    let isInvalid = false;
    isInvalid = meta.touched && !isEmpty(meta.error);

    const currentVals = meta.value.reduce((o, k) => ((o[k] = true), o), {}); //array to obj: https://stackoverflow.com/a/56276007/11297747
    const [rowSelection, setRowSelection] = React.useState(currentVals);

    React.useEffect(() => {
        helpers.setValue(Object.keys(rowSelection), true);
    }, [rowSelection]);

    React.useEffect(() => {
        setRowSelection(currentVals);
    }, [resetCount]);

    return (
        <>
            {!isEmpty(rows) && (
                <div className={cx('col-sm-8')}>
                    <h3>
                        Consumable Effects
                        {isInvalid && (
                            <FormFeedback
                                isInvalid={isInvalid}
                                errorMessage={meta.error}
                            />
                        )}
                    </h3>

                    <MaterialReactTable
                        columns={columns}
                        data={rows}
                        enableRowSelection //enable some features
                        enableColumnOrdering
                        enableGlobalFilter={false} //turn off a feature
                        getRowId={(row) => row.id} //give each row a more useful id
                        onRowSelectionChange={function (...args) {
                            setRowSelection(args[0]);
                        }} //connect internal row selection state to your own
                        state={{ rowSelection }} //pass our managed row selection state to the table to use
                        muiTableProps={{
                            sx: {
                                tableLayout: 'fixed',
                            },
                        }}
                        muiTableBodyRowProps={({ row }) => {
                            return {
                                onClick: row.getToggleSelectedHandler(),
                                sx: { cursor: 'pointer' },
                            };
                        }}
                        enableColumnResizing
                        columnResizeMode="onChange"
                    />
                </div>
            )}
        </>
    );
}

// ConsumableEffectTable.defaultProps = {
//     resetCount: ,
// };
ConsumableEffectTable.propTypes = {
    resetCount: PropTypes.number.isRequired,
};
export default ConsumableEffectTable;
